import React, { useEffect, useState } from "react";
import "./takeaway.scss";
import { Button, Typography, Input, message } from "antd";
import TimesFeaturedStoryTableContent from "../../components/dataTable/b2b/TimesFeaturedStoryTable";
import { otherContentsSVC, timesSVC } from "../../services";
import ReactQuill from "react-quill";
import moment from "moment";
import { AppModal, AppUpload } from "../../components/common";
const { Text } = Typography;

interface Contentdata {
  key?: string;
  id: number;
  title: string;
  type: string;
  content: string;
  link: string;
  image: string;
  sheduledDate: string;
}
function TimesFeaturedStory() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [editContent, setEditContent] = useState<any>({
    _id: "",
    id: "",
    title: "",
    content: "",
    link: "",
    image: "",
    sheduledDate: null,
  });
  const [contentData, setContentData] = useState<Contentdata[]>([]);
  const [uploadedImage, setUploadedImage] = useState<any>(null);
  const [loading, setloading] = useState<boolean>(false);
  const [btnDisable, setBtnDisable] = useState(false);

  const getOtherContent = async () => {
    timesSVC
      .getAllfeaturedStory()
      .then((res: any) => {
        setContentData(res.data.data);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  // const filteredData = contentData.filter((item) => item.type === "takeaway");
  useEffect(() => {
    getOtherContent();
  }, []);

  const deleteOtherContent = (id: string) => {
    otherContentsSVC
      .deleteOtherContenttime(id)
      .then((res: any) => {
        getOtherContent();
        message.success("Deleted Successfully");
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const updateOtherContent = (id: string) => {
    setloading(true);
    const formData: any = new FormData();
    formData.append("title", editContent.title);
    formData.append("type", "takeaway");
    formData.append("content", editContent.content);
    formData.append("link", editContent.link);
    formData.append("image", editContent.image);
    if (editContent.sheduledDate !== null) {
      formData.append("sheduledDate", editContent.sheduledDate);
    } else {
      formData.append("sheduledDate", moment().format("YYYY-MM-DD"));
    }
    otherContentsSVC
      .updateOtherContenttimes(id, formData)
      .then((res: any) => {
        setloading(false);
        getOtherContent();
        message.success("Updated Successfully");
        handleCancel();
      })
      .catch((err: any) => {
        message.error(err.message);
        setloading(false);
      });
  };
  const addOtherContent = () => {
    setloading(true);
    const formData: any = new FormData();
    formData.append("title", editContent.title);
    formData.append("content", editContent.content);
    formData.append("image", editContent.image);
    formData.append("link", editContent.link);

    otherContentsSVC
      .TFStoryCreate(formData)
      .then((res: any) => {
        setloading(false);
        getOtherContent();
        message.success("Added Successfully");
        setEditContent({
          _id: "",
          id: "",
          title: "",
          image: "",
          content: "",
        });
        setUploadedImage(null);
        handleCancel();
      })
      .catch((err: any) => {
        message.error(err.message);
        setloading(false);
      });
  };
  const editOtherContent = (record: any) => {
    setEditContent({
      _id: record._id || record.id,
      id: record.id || record._id,
      title: record.title,
      content: record.content,
      link: record.link,
      image: record.image,
      sheduledDate: record.sheduledDate,
    });
  };

  const showModal = () => {
    handleCancel();
    setIsModalOpen(true);
    setIsEditable(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditContent({
      _id: "",
      id: "",
      title: "",
      image: "",
      content: "",
      link: "",
      sheduledDate: null,
    });
    setUploadedImage(null);
    setloading(false);
  };

  const handleFileUpload = async (event: any) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      message.error("Image size should not exceed 10MB");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setUploadedImage(reader.result);
    };
    setBtnDisable(false);
    setEditContent((preData: any) => ({
      ...preData,
      image: file,
    }));

    reader.readAsDataURL(file);
  };

  const handleInputChange = (event: any) => {
    setBtnDisable(false);
    const { name, value } = event.target;
    setEditContent((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleDescription = (value: any) => {
    setBtnDisable(false);
    setEditContent((preData: any) => ({
      ...preData,
      content: value,
    }));
  };
  return (
    <div className="contentBox">
      <div className="info">
        <Text className="title24">Featured Story</Text>
      </div>
      <TimesFeaturedStoryTableContent
        deleteOtherContent={deleteOtherContent}
        editContent={editOtherContent}
        setshowModel={setIsModalOpen}
        setEditable={setIsEditable}
        showModal={showModal}
        isOpen={isModalOpen}
        contentData={contentData}
      />
      <AppModal
        title={
          isEditable === true ? "Update  Featured Story" : "Add Featured Story"
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Input
          className="input"
          name="title"
          onChange={handleInputChange}
          size={"large"}
          style={{ borderRadius: "10px" }}
          value={editContent.title}
          placeholder={"Enter Title"}
        />

        {editContent.title === "" ? null : (
          <>
            <br />
            <br />
            <ReactQuill
              value={editContent.content}
              onChange={handleDescription}
              modules={{
                toolbar: [
                  // [{ 'header': '1' }, { 'header': '2' }],
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"],
                  ["clean"],
                ],
              }}
            />
          </>
        )}
        {editContent.content === "" ? null : (
          <>
            <br />
            <br />
            <Input
              type="url"
              name="link"
              onChange={handleInputChange}
              size={"large"}
              style={{ borderRadius: "10px" }}
              value={editContent.link}
              placeholder={"Enter Link"}
            />
          </>
        )}
        {editContent.link === "" ? null : (
          <>
            <br />
            <br />
            <AppUpload
              image={editContent?.image}
              uploadedImage={uploadedImage}
              handleFileUpload={handleFileUpload}
            />
          </>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={() => {
              if (editContent.title === "") {
                message.info("Please Enter T");
                setBtnDisable(true);
              } else if (editContent.content === "") {
                message.info("Please Enter Content");
              } else if (editContent.link === "") {
                message.info("Please Enter link");
              } else {
                if (isEditable === true) {
                  updateOtherContent(editContent._id || editContent.id || "");
                } else {
                  if (editContent.image === "") {
                    message.info("Please upload a image");
                  } else {
                    addOtherContent();
                  }
                }
              }
            }}
            style={{
              marginTop: "10px",
            }}
            className="button"
            loading={loading}
            disabled={btnDisable ? true : false}
          >
            {isEditable === true ? "Update " : "Add"}
          </Button>
        </div>
      </AppModal>
    </div>
  );
}

export default TimesFeaturedStory;
